//Note server.js, 
//In the stripeserver Folder, server.js is a stripe server side code that needs to be Started 
//with command::  npm run start

// KenMacMini:stripeserver admin$ pwd
// /Users/admin/Documents/Coding2022/boameooo-portal/stripeserver
// KenMacMini:stripeserver admin$ 

import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import StripeCheckoutForm from "./StripeCheckoutForm";
//import "./App.css";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
const stripePromise = loadStripe("pk_test_51HpAl6JB2zoYndMet9u9EZBDpvFhHoCNCsgiFxPPgWCx4B7trCOlWjSV0F5GZoGrVUV4dcn8GnjVuAsyGpjcWGxO008JGSD9YH");

export default function StripeDocPayment() {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, []);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <StripeCheckoutForm />
        </Elements>
      )}
    </div>
  );
}